import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={20}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={0.5} y={0.5} fill='url(#edge_svg__a)' rx={9.5} />
    <rect width={19} height={19} x={0.5} y={0.5} stroke='#E0E3EB' rx={9.5} />
    <defs>
      <pattern id='edge_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#edge_svg__b' transform='scale(.0039)' />
      </pattern>
      <image
        xlinkHref='/images/icons/edge-b029e728.webp'
        id='edge_svg__b'
        width={256}
        height={256}
      />
    </defs>
  </svg>
);
export default SvgEdge;
